import { styled } from '@clickcease/cc-client-components-lib'

export const PaymentMethodModalStyled = styled('div', {
  width: '500px',
  padding: '12px 24px 18px 24px',
})

export const PaymentMethodModalCountryAndState = styled('div', {
  display: 'flex',
  height: '50px',
  marginTop: '$9',
  justifyContent: 'space-between',
})

export const PaymentMethodModalCountryAndStateError = styled('div', {
  color: '$error',
  height: '$12',
})
